import { useState } from 'react';

export default () => {
  const [editId, setEditId] = useState<string>('create');
  const [showEdit, setShowEdit] = useState<boolean>(false);

  const getFormatRefundCurrency = (key: any) => {
    if (key && typeof key === 'string') {
      const formatRefundCurrency = {
        '$': 'USD',
        '£': 'GBP',
        '€': 'EUR'
      };
      const keys = Object.keys(formatRefundCurrency);
      if (keys.includes(key)) {
        return formatRefundCurrency[key];
      } else {
        const dataList = keys.find(_key => formatRefundCurrency[_key] === key);
        if (dataList) {
          return dataList[0];
        }
        return null;
      }
    }
    return null;
  };

  const reSet = () => {
    setEditId('create');
    setShowEdit(false);
  };

  const toOriginalInput = (refundCurrency: string, refundAmount: string, refundMessageHtml: string) => {
    let _text = '';
    if (refundMessageHtml && typeof refundMessageHtml === 'string') {
      _text = refundMessageHtml || '';
    }
    if (refundCurrency) {
      const regex = /<span style="color: rgb\(24, 144, 254\);">(?!\s*$).*?<\/span>/g;
      _text = _text.replace(regex, '<span style="color: rgb(24, 144, 255);">{币种}</span>');
    }
    if (refundAmount) {
      const regex = /<span style="color: rgb\(24, 144, 254\); background-color: transparent;">(?!\s*$).*?<\/span>/g;
      const regexRe = /<span style="background-color: transparent; color: rgb\(24, 144, 254\);">(?!\s*$).*?<\/span>/g;
      _text = _text.replace(regex, '<span style="color: rgb(24, 144, 255); background-color: transparent;">{金额}</span>');
      _text = _text.replace(regexRe, '<span style="color: rgb(24, 144, 255); background-color: transparent;">{金额}</span>');
    }
    return _text;
  };

  const toShowInput = (refundCurrency: string, refundAmount: string, refundMessageHtmlBase: string) => {
    let _text = '';
    if (refundMessageHtmlBase && typeof refundMessageHtmlBase === 'string') {
      _text = refundMessageHtmlBase || '';
    }
    if (refundCurrency) {
      const regex = /<span style="color: rgb\(24, 144, 255\);">(?!\s*$).*?<\/span>/g;
      _text = _text.replace(regex, `<span style="color: rgb(24, 144, 254);">${refundCurrency.toString()}</span>`);
    }
    if (refundAmount) {
      const regex = /<span style="color: rgb\(24, 144, 255\); background-color: transparent;">(?!\s*$).*?<\/span>/g;
      const regexRe = /<span style="background-color: transparent; color: rgb\(24, 144, 255\);">(?!\s*$).*?<\/span>/g;
      _text = _text.replace(regex, `<span style="color: rgb(24, 144, 254); background-color: transparent;">${refundAmount?.toString()}</span>`);
      _text = _text.replace(regexRe, `<span style="color: rgb(24, 144, 254); background-color: transparent;">${refundAmount?.toString()}</span>`);
    }
    return _text;
  };

  return {
    editId,
    setEditId,
    showEdit,
    setShowEdit,
    reSet,

    toShowInput,
    toOriginalInput,
    getFormatRefundCurrency,

  };
};
